import { store } from 'react-notifications-component';

const showNotification = (type, message, container, duration) => {
    store.addNotification({
        message: message || 'Error',
        type: type,
        insert: 'top',
        container: container || 'bottom-left',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
            duration: duration || 3000,
            onScreen: true,
            showIcon: true,
        },
        slidingExit: {
            duration: 100,
            timingFunction: 'linear',
            delay: 0,
        },
    });
};

export default showNotification;
